import React, { Component } from "react";
import $ from "jquery";
import Slide from "../../MyFiles/Slide/Slide13.jpg";
import Condition from "../../MyFiles/ArbaeinCondition1405.jpg";

class Register extends Component {
  state = {
    userQuranTypeJson: [],
    userCompetitionRequestJson: [],
    errorMessage: "",
    stepNo: 1,
    isRegister: true,
  };
  componentDidMount() {
    this.getRequest();
  }
  toggleRegister = () => {
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleEdit = () => {
    this.props.getAllUserRelation();
    this.setState({ stepNo: 2 });
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleSubmit = () => {
    if (this.state.stepNo === 1) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 2 });
    }
    if (this.state.stepNo === 2) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 3 });
    }
    if (this.state.stepNo === 3) {
      this.submitForm();
    }
  };
  toggledecline = () => {
    if (this.state.stepNo === 1) {
      this.setState({ isRegister: !this.state.isRegister });
    }
    if (this.state.stepNo === 2) {
      this.setState({ stepNo: 1 });
    }
    if (this.state.stepNo === 3) {
      this.setState({ stepNo: 2 });
    }
  };
  submitForm = () => {
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
      var SendRequest = false;
      var selectRelationID = 0;
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      if (cusid_ele.length !== 0) {
        for (var i = 0; i < cusid_ele.length; ++i) {
          var item = cusid_ele[i];
          if (item.classList.contains("active") === true) {
            var Value = $(item).attr("data-target");
            selectRelationID =
              selectRelationID === 0
                ? (selectRelationID = Value)
                : (selectRelationID = selectRelationID + "," + Value);
          }
          if (i === cusid_ele.length - 1) {
            SendRequest = true;
          }
        }
      }
      if (selectRelationID === 0) {
        errorMessage = "همراهان خود را انتخاب نمایید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        if (SendRequest === true) {
          var formdata = new FormData();
          var SelectOne = document.getElementById("SelectOne").value;
          var SelectTwo = document.getElementById("SelectTwo").value;
          formdata.append("token", token);
          formdata.append("CompetitionRequestTypeRef", 1);
          formdata.append("ID_Relation", selectRelationID);
          formdata.append("Details", SelectOne + " - Two: " + SelectTwo);

          var requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
          };

          fetch(
            `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-register`,
            requestOptions,
          )
            .then((response) => response.text())
            .then((result) => {
              if (result !== null) {
                var myObject = JSON.parse(result);
                if (myObject.status === 0) {
                  this.getRequest();
                  errorMessage = "درخواست شما با موفقیت در سامانه ثبت شد.";
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                  this.toggleRegister();
                } else {
                  errorMessage = myObject.message;
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                }
              }
            })
            .catch((error) => console.log("error", error));
        }
      }
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  handleRequest = (e) => {
    this.declineRequest(e);
  };
  declineRequest = (e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      formdata.append("CompetitionRequestTypeRef", 1);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-competition-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getRequest();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("CompetitionRequestTypeRef", 1);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-competition-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { userCompetitionRequestJson: myObject.data },
                function() {
                  console.log(this.state.userCompetitionRequestJson);
                },
              );
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  selectRelation = (id, e) => {
    if (id !== null) {
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var getValue = $(item).attr("data-target");
        if (getValue !== null && getValue.includes(id)) {
          item.classList.toggle("active");
        }
      }
    }
  };
  render() {
    const Relation_Active = this.props.userRelationsJson
      .filter((ee) => ee.Relation_ID === 10 || ee.Relation_ID === 11)
      .map((e) =>
        e.NeedEdit !== true ? (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvCandidate"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <div className="row">
                <div className="col-2 m-auto checkbox">
                  <label className="containerCustom">
                    <input
                      type="checkbox"
                      value={e.ID}
                      onClick={() => this.selectRelation(e.ID, this)}
                      name="Candidate"
                    ></input>
                    <span className="checkmark"></span>
                  </label>
                  {/* <input type="radio" name='Candidate'  /> */}
                </div>
                <div className="col-10 p-2">
                  <span className="bg-dark text-white wp-text-small rounded px-2 py-0">
                    جنسیت: {e.Sex}
                  </span>{" "}
                  <span className="bg-dark text-white wp-text-small rounded px-2 py-0 mr-2">
                    نسبت: {e.Relation_Title}
                  </span>
                  <div className="title mt-1">
                    کدملی: <b>{e.National_Code}</b>
                  </div>
                  <div className="title mt-1">
                    <strong>
                      {e.F_Name} {e.L_Name}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvRelation disable"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <span className="bg-dark text-white wp-text-small rounded px-2 py-0">
                جنسیت: {e.Sex}
              </span>{" "}
              <span className="bg-dark text-white wp-text-small rounded px-2 py-0 mr-2">
                نسبت: {e.Relation_Title}
              </span>
              <div className="title mt-1">
                <strong>
                  {e.F_Name} {e.L_Name}
                </strong>
              </div>
              <div className="describe">
                کدملی: <b>{e.National_Code}</b>
              </div>
              <span className="bg-danger text-white wp-text-small px-2">
                عدم امکان انتخاب به دلیل نقص در اطلاعات فرد
              </span>
            </div>
          </div>
        ),
      );
    const myRelation = this.props.userRelationsJson
      .filter((ee) => ee.Relation_ID === 10 || ee.Relation_ID === 11)
      .map((e) => (
        <li key={e.ID} className={"Array-item readClass"}>
          <span className="bg-dark text-white wp-text-small rounded p-1">
            جنسیت: {e.Sex}
          </span>{" "}
          <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
            نسبت: {e.Relation_Title}
          </span>
          <div className="title mt-1">
            <strong>
              {e.F_Name} {e.L_Name}
            </strong>
          </div>
          <div className="describe">
            کدملی: <b>{e.National_Code}</b>
          </div>
          <div className="describe">
            ش.شناسنامه: <b>{e.Identity_Code}</b>
          </div>
          <div className="describe">
            تاریخ تولد: <b>{e.DateOfBirthday}</b>
          </div>
          <div className="describe">
            محل صدور: <b>{e.Sodor_City}</b>
          </div>
          <div className="text-left">
            <span className={e.State_CSS}>{e.State_Title}</span>
          </div>
          {e.NeedEdit === true ? (
            <React.Fragment>
              <span className="bg-danger text-white wp-text-small">
                اطلاعات این فرد ناقص است، لطفاً نسبت به تکمیل اطلاعات فرد اقدام
                نمایید.
              </span>
              <div className="text-left">
                <button
                  type="button"
                  onClick={() => this.props.getUserRelation(e.ID)}
                  className="btn btn-warning btn-sm rounded-0 py-0 px-1 small-font"
                >
                  ویرایش
                </button>
              </div>
            </React.Fragment>
          ) : null}
        </li>
      ));
    const myRequest = this.state.userCompetitionRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <li key={e.ID} className={"Array-item readClass"}>
          <span className="bg-dark text-white wp-text-small rounded p-1">
            تاریخ درخواست {e.RequestTime}
          </span>
          <div className="title mt-2">
            <strong>{e.Comment}</strong>
          </div>
          <div className="describe bg-dark p-1 text-white">
            تعداد همراهان:{" "}
            <b className="text-white font-weight-bold">{e.Count}</b>
          </div>
          <div className="describe mt-2">
            {e !== null &&
            e.data_addition !== null &&
            e.data_addition.length > 0 &&
            e.Count > 0
              ? e.data_addition.map((ee) => {
                  return (
                    <p className="mb-1">
                      <span className="badge bg-success p-2"> </span>{" "}
                      {ee.Relation_Title} - {ee.F_Name} {ee.L_Name} (کدملی{" "}
                      {ee.National_Code})
                    </p>
                  );
                })
              : null}
          </div>
          <div className="text-left">
            <span className={e.State_CSS}>{e.State_Title}</span>
          </div>
          {e.State === "1" ? (
            <div className="text-left">
              <button
                type="button"
                onClick={() => this.handleRequest(e.ID)}
                className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
              >
                انصراف
              </button>
            </div>
          ) : null}
        </li>
      </li>
    ));
    if (this.state.isRegister === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <p className="wp-header small">وضعیت ثبت نام</p>
            <ul className="Array p-0 mb-5">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="title">
                    هنوز درخواست شما در سیستم ثبت نشده است.
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            {myRequest.length === 0 ? (
              <button
                onClick={this.toggleRegister}
                className="btn btn-success wp-button-add"
              >
                <span>ثبت درخواست</span>
              </button>
            ) : (
              <button
                onClick={this.toggleEdit}
                className="btn btn-primary wp-button-add"
              >
                <span>ویرایش درخواست</span>
              </button>
            )}
          </div>
        </React.Fragment>
      );
    } else {
      if (this.state.stepNo === 1) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <div className="row justify-content-center">
                <p className="text-center font-weight-bold"></p>
                <div className="col-12 mb-2">
                  <React.Fragment>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      className="wp-link"
                      href={Condition}
                    >
                      <img
                        className="w-100"
                        src={Slide}
                        alt="پیاده روی اربعین"
                      ></img>
                    </a>
                  </React.Fragment>
                </div>
                <div className="col-12 mb-2">
                  <p className="text-center">
                    قبل از ثبت نام در پیاده‌روی اربعین حسینی ابتدا شرایط آن را
                    از طریق لینک طریق لینک زیر دریافت و آن را مطالعه نمایید.{" "}
                  </p>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    className="btn btn-sm btn-primary wp-link"
                    href={Condition}
                  >
                    مشاهده شرایط
                  </a>
                </div>
                <div className="col-12 text-left">
                  <button
                    onClick={this.toggledecline}
                    className="btn btn-sm btn-danger"
                  >
                    <span>انصراف</span>
                  </button>
                  <button
                    onClick={this.toggleSubmit}
                    className="btn btn-sm btn-success mr-2"
                  >
                    <span>ادامه</span>
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 2) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              {/* <div className="alert alert-info p-1 mt-2">
                <p className="text-justify mb-0">
                  در صورتی که اطلاعات همسر و فرزندان شما ناقص است نسبت به افزودن
                  و بروزرسانی آن اقدام کنید.
                </p>
                <div className="text-left">
                  <button
                    onClick={this.props.toggleRelation}
                    className="btn btn-sm btn-primary"
                  >
                    <span>+ افزودن</span>
                  </button>
                </div>
              </div> */}
              <div className="row justify-content-center">
                <div className="col-12">
                  <ul className="Array p-0 mb-2">
                    {myRelation.length === 0 ? (
                      <li className="Array-item">
                        <div className="title">
                          اطلاعات اعضای خانوار شما در سامانه ثبت نشده است.
                        </div>
                      </li>
                    ) : (
                      myRelation
                    )}
                  </ul>
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>تایید و ادامه</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 3) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <div className="alert alert-info p-1 my-2">
                <p className="mb-0">
                  حضور سرپرست خانواده در سفر الزامی است. در صورتی که همراه دارید
                  از آن ها را انتخاب نمایید.
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-12">
                  <p className="mb-0 font-weight-bold text-danger">
                    + انتخاب همراهان
                  </p>
                </div>
                <div className="col-12">
                  <ul className="Array p-0 mb-2 list-group">
                    <li className="list-group-item ">
                      <div
                        key={this.props.userJson.id}
                        className="col-12 mb-2 bg-light dvCandidate active"
                        data-target={this.props.userJson.id}
                      >
                        <div className="w-100 rounded p-1">
                          <div className="row">
                            <div className="col-2 m-auto checkbox">
                              <label className="containerCustom">
                                <input
                                  type="checkbox"
                                  value={this.props.userJson.id}
                                  checked="checked"
                                  name="Candidate"
                                  readOnly="readonly"
                                ></input>
                                <span className="checkmark"></span>
                              </label>
                              {/* <input type="radio" name='Candidate'  /> */}
                            </div>
                            <div className="col-10 p-2">
                              <span className="bg-success text-white wp-text-small rounded px-2 py-0">
                                نسبت: نفر اصلی
                              </span>
                              <div className="title mt-1">
                                کدملی: <b>{this.props.userJson.national_id}</b>
                              </div>
                              <div className="title mt-1">
                                <b>{this.props.userJson.full_name}</b>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Relation_Active.length === 0 ? null : Relation_Active}
                    </li>
                  </ul>
                </div>
                <div className="col-12 mb-2">
                  <label className="font-weight-bold">انتخاب کاروان</label>
                  <select
                    id="SelectOne"
                    name="SelectOne"
                    type="text"
                    className="form-select form-select-lg text-center wp-input-text rounded-0"
                    placeholder="انتخاب کاروان"
                    defaultValue=""
                  >
                    <option value="1">کاروان اول</option>
                    <option value="2">کاروان دوم</option>
                  </select>
                </div>
                <div className="col-12 mb-2">
                  <label className="font-weight-bold">انتخاب وسیله نقلیه</label>
                  <select
                    id="SelectTwo"
                    name="SelectTwo"
                    type="text"
                    className="form-select form-select-lg text-center wp-input-text rounded-0"
                    placeholder="انتخاب وسیله نقلیه"
                    defaultValue=""
                  >
                    <option value="1">ماشین شخصی</option>
                    <option value="2">کاروان اتوبوسی</option>
                  </select>
                </div>
                <div className="col-12">
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>ثبت نهایی درخواست</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    }
  }
}
export default Register;
